import React from "react";
import { CLIENT_TYPES, MARTINIQUE_BG, BRAND } from "@/site.config";
import { MapPin } from "lucide-react";

export default function InterventionZone() {
  return (
    <section
      id="zone"
      data-testid="zone-section"
      className="relative py-24 sm:py-32 px-5 sm:px-8 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={MARTINIQUE_BG}
          alt=""
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-black/85 to-[#0A0A0A]" />
        <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-[#9DEB30]/8 blur-[160px]" />
      </div>

      <div className="relative max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#9DEB30] mb-3">
            · Zone d'intervention
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight">
            Présents sur{" "}
            <span className="text-[#9DEB30] neon-text">toute la Martinique.</span>
          </h2>
          <p className="mt-5 text-zinc-400 max-w-xl text-base">
            De Saint-Pierre au Marin, du Lamentin à Sainte-Anne — nos équipes interviennent
            chez les particuliers comme dans les infrastructures publiques.
          </p>

          <div className="mt-8 grid grid-cols-2 gap-3 max-w-md">
            {CLIENT_TYPES.map((c, i) => (
              <div
                key={i}
                data-testid={`zone-client-${i}`}
                className="px-4 py-3 rounded-xl border border-white/10 bg-white/[0.02] text-sm text-zinc-200 hover:border-[#9DEB30]/40 transition"
              >
                {c}
              </div>
            ))}
          </div>

          <div className="mt-10 inline-flex items-center gap-3 text-sm text-zinc-300">
            <MapPin size={16} className="text-[#9DEB30]" />
            {BRAND.zone}
          </div>
        </div>

        <div className="relative">
          <div className="aspect-square max-w-[520px] mx-auto relative">
            <div className="absolute inset-0 rounded-full border border-[#9DEB30]/20 animate-[pulseGlow_4s_ease-in-out_infinite]" />
            <div className="absolute inset-8 rounded-full border border-[#9DEB30]/15" />
            <div className="absolute inset-16 rounded-full border border-[#9DEB30]/10" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center">
                <div className="font-display text-7xl sm:text-8xl font-extrabold text-[#9DEB30] neon-text">
                  972
                </div>
                <div className="mt-2 font-mono text-xs uppercase tracking-[0.3em] text-zinc-400">
                  Martinique
                </div>
                <div className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#9DEB30]/10 border border-[#9DEB30]/30">
                  <span className="h-1.5 w-1.5 rounded-full bg-[#9DEB30] pulse-glow" />
                  <span className="text-[10px] font-mono text-[#9DEB30] uppercase tracking-wider">
                    Disponible
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
